import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import custom_css from './assets/css/custom.css'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import 'uikit/dist/css/uikit.css'
import 'uikit/dist/css/uikit.min.css'
import firebase from 'firebase'
UIkit.use(Icons)



var firebaseConfig = {
  apiKey: "AIzaSyBa_F2K3V0fcIgdz7DxFrplccdIDcefI6s",
  authDomain: "tabletennis-81e9d.firebaseapp.com",
  databaseURL: "https://tabletennis-81e9d.firebaseio.com",
  projectId: "tabletennis-81e9d",
  storageBucket: "tabletennis-81e9d.appspot.com",
  messagingSenderId: "392446494150",
  appId: "1:392446494150:web:4dc85a99b7bcd8d9ecdec7",
  measurementId: "G-KZ2936RSC2"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
createApp(App).use(store).use(router).use(custom_css).mount('#app')